export const environment = {
  production: false,
  apiUrl: 'https://homolog.api.digital.itcnet.com.br',
  baseUrl: 'https://homolog.digital.itcnet.com.br',
  paymentUrl: 'https://homolog.pagamento.itcnet.com.br',
  keycloak: {
    authority: 'https://homolog.login.itcnet.com.br',
    redirectUri: 'https://homolog.digital.itcnet.com.br/servicos',
    postLogoutRedirectUri: 'https://itcnet.com.br/auth/keycloak/logout.php',
    realm: 'itcnet',
    clientId: 'itc_digital_clientid',
  }
};